import { APIProvider } from '@vis.gl/react-google-maps';
import * as React from 'react';

// Web: single APIProvider instance for the entire app.
// All maps (event map tab, location preview, etc.) share this one instance
// so the Maps JS SDK is only initialized once — mounting multiple APIProviders
// with the same key causes "This page can't load Google Maps correctly".
export function GoogleMapsProvider({ children }: { children: React.ReactNode }) {
  return (
    <APIProvider
      apiKey={process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY ?? ''}
      authReferrerPolicy="origin"
      libraries={['marker']}>
      {children}
    </APIProvider>
  );
}
